import { render, staticRenderFns } from "./clienti.html?vue&type=template&id=02c40cb9&"
import script from "./Clienti.vue?vue&type=script&lang=js&"
export * from "./Clienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports